import React from "react";
import Header from "../parts/header";
import Leftbar from "../parts/leftbarCoaching";
import { ReferralLinkProgram } from "../parts/modals/referral-link-program";

function Page({ children }, { locals }) {
  const { activeUser, query } = locals;
  const { modal = {} } = query;

  return (
    <div id="coaching-wrapper">
      <label htmlFor="mobile-nav-toggle" />
      <Header coachingPortalEnabled />
      <Leftbar />
      {children}
      {modal?.type === "referral-link-program" && (
        <ReferralLinkProgram activeUser={activeUser} />
      )}
    </div>
  );
}

export default Page;
